import { createSelector } from '@ngrx/store';
import { selectResult } from '@oca/web-shared';
import { appFeature } from './app.reducer';

export const selectAppInfo = createSelector(appFeature.selectAppInfo, selectResult);
